import { Injectable, inject, signal, computed } from '@angular/core';
import { finalize } from 'rxjs';
import { ClientAccount } from '../models';
import { AdminScanService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class ClientAccountStore {
  private readonly adminScanService = inject(AdminScanService);

  readonly accounts = signal<ClientAccount[]>([]);
  readonly isLoading = signal(false);

  readonly hasAccounts = computed(() => this.accounts().length > 0);

  loadAccounts(): void {
    this.isLoading.set(true);
    this.adminScanService
      .getClientAccounts()
      .pipe(finalize(() => this.isLoading.set(false)))
      .subscribe({
        next: (accounts) => {
          this.accounts.set(accounts);
        },
        error: (err) => {
          console.error('Account load failed:', err);
          this.accounts.set([]);
        },
      });
  }

  clear(): void {
    this.accounts.set([]);
  }
}
